import React, { Component } from 'react';
import styled from 'styled-components';
import ButtonText from 'components/ButtonText';
import PropTypes from 'prop-types';
import { listHeaderSecondaryButtonStyles } from 'constants/listHeaderButtons';
import { Colors } from 'modules/theme';

const logoutButtonStyles = {
  ...listHeaderSecondaryButtonStyles,
  border: `1px solid ${Colors.orange}`,
  color: Colors.orange,
  backgroundColor: Colors.white,
};

const Container = styled.div`
  margin: 0 0 20px 0;
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  @media (max-width: 767px) {
    justify-content: stretch;
  }
`;

const ButtonWrap = styled.div`
  @media (max-width: 767px) {
    width: 100%;
    & > button {
      width: 100%;
      box-sizing: border-box;
    }
  }
`;

export default class LogoutView extends Component {
  render() {
    const { logout } = this.props;

    return (
      <Container>
        <ButtonWrap>
          <ButtonText
            text="Logout"
            icon="sign-out-alt"
            theme="basic"
            color={Colors.orange}
            customStyles={logoutButtonStyles}
            onClick={logout}
          />
        </ButtonWrap>
      </Container>
    );
  }
}

LogoutView.propTypes = {
  logout: PropTypes.func.isRequired,
};
